export default "__VITE_PUBLIC_ASSET__4a542b30__"